import React from 'react';
import './ChevronProcessDiagram.scss';
import { ChevronDiagramEvent } from './models/ChevronDiagramEvent';
import { formatBusinessDatePt } from '../../../slices/marketplace/timeline/utils/timeline-dates';

interface ChevronDiagramBreakMarkerProps {
    marker: ChevronDiagramEvent;
}

// [#1298 / #1300] Where a break fell on this timeline: a marker, not a step - no party, deadline or action. It reads the
// whole break `[PO 15-Oct]`: from the day it fell until this timeline moved again, and "Suspended since" that day while
// it lasts `[PO 15-Oct]`. A marker written before breaks had an end shows its one day.
const breakPeriod = (marker: ChevronDiagramEvent): string => {
    const brokeOn = formatBusinessDatePt(marker.dayStart);
    if (!marker.dayCompleted) {
        return `Suspended since ${brokeOn}`;
    }

    const endedOn = formatBusinessDatePt(marker.dayCompleted);
    return endedOn === brokeOn ? `Date: ${brokeOn}` : `Date: ${brokeOn} – ${endedOn}`;
};

export const ChevronDiagramBreakMarker = (props: ChevronDiagramBreakMarkerProps) => {
    return (
        <div>
            <div className="column-item suspended-event break-marker">
                <div className="event-name">{props.marker.name}</div>
                <div className="start-date">{breakPeriod(props.marker)}</div>
            </div>
        </div>
    );
};
